@if (isSearchOverlayVisible) {
    <cc-search [lobbyType]="lobbyType"></cc-search>
}
